import { create, StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { GameState } from './types';
import { initialState } from './initialState';
import {
  createFetchHits,
  createRecordHit,
  createUpdateHit,
  createDeleteHit,
  createFetchLedger,
  createRecordPayment,
  createMarkWinningsPaid,
} from './actions';

const createGameStore: StateCreator<GameState, [['zustand/devtools', never]]> = (set, get) => ({
  ...initialState,

  // Hit Actions
  fetchHits: createFetchHits(set),
  recordHit: createRecordHit(get),
  updateHit: createUpdateHit(get),
  deleteHit: createDeleteHit(get),

  // Ledger Actions
  fetchLedger: createFetchLedger(set),
  recordPayment: createRecordPayment(get),
  markWinningsPaid: createMarkWinningsPaid(get),

  // Utilities
  clearHitsError: () => set({ hitsError: null }),
  clearLedgerError: () => set({ ledgerError: null }),
  reset: () => set(initialState),
});

export const useGameStore = create<GameState>()(
  devtools(createGameStore, { name: 'game-store' })
);

// Re-export types
export type { GameState } from './types';

// Re-export selectors
export {
  selectHits,
  selectIsLoadingHits,
  selectHitsError,
  selectHitByQuarter,
  selectRecordedQuarters,
  selectLastRecordedQuarter,
  selectAllQuartersRecorded,
  selectLedgerEntries,
  selectLedgerSummary,
  selectIsLoadingLedger,
  selectLedgerError,
  selectTotalPot,
  selectTotalPaidOut,
  selectUserBalance,
  selectUnpaidBalances,
  selectWinnerBalances,
} from './selectors';
